import moment from 'moment';
import { ISearch } from './i-search';
import { Query } from './query';


export class Search {
  userName?: string;
  createdDate?: Date;
  _createdDate?: string;
  updatedDate?: Date;
  _updatedDate?: string;
  lastChangedUserName?: string;
  lastChangedUserLoginName?: string;
  organizationName?: string;
  lastRunDate?: string;
  lastRunStatus?: string;
  lastRunStatusSort?: number;
  queryName?: string;
  queryId?: number;
  scheduledSearchRunFrequency?: string;
  query: Query;

  constructor(searchData: ISearch) {
    this.userName = searchData.userName;
    this.createdDate = new Date(searchData.createdDate);
    this._createdDate = searchData.createdDate;

    if (searchData.updatedDate) {
      this.updatedDate = new Date(searchData.updatedDate);
      this._updatedDate = searchData.updatedDate;
    } else {
      this.updatedDate = null;
      this._updatedDate = '';
    }

    this.lastChangedUserName = searchData.lastChangedUserName;
    this.lastChangedUserLoginName = searchData.lastChangedUserLoginName;
    this.organizationName = searchData.organizationName;
    if (searchData.lastRunStatus) this.lastRunStatus = searchData.lastRunStatus.toLowerCase(); else this.lastRunStatus = '';
    if (searchData.lastRunStatusSort) this.lastRunStatusSort = searchData.lastRunStatusSort; else this.lastRunStatusSort = 0;
    this.queryName = searchData.queryName;
    this.queryId = searchData.queryId;
    this.scheduledSearchRunFrequency = searchData.scheduledSearchRunFrequency ? searchData.scheduledSearchRunFrequency : '';
    this.query = searchData.query;
  }

  get formattedCreateDate(): string {
    return moment(this.createdDate).format('MM/DD/YYYY h:mm A');
  }

  get formattedLastRunDate(): string {
    if (this.lastRunDate) {
      return moment(this.lastRunDate).format('MM/DD/YYYY h:mm A');
    }
    return moment(this.createdDate).format('MM/DD/YYYY h:mm A');
  }

  get runFrequencyFilter(): string {
    if (this.scheduledSearchRunFrequency === 'W') {
      return 'Weekly';
    }
    if (this.scheduledSearchRunFrequency === 'M') {
      return 'Monthly';
    }
    return '';
  }
}
